// store/modules/selectPage.js
export default {
    namespaced: true,
    state: {
        allPages: {},
        pageSelected: [],
        groups: [],
        listRetracted: false,

        // for select page
        formatData: {
            groups: {},
            otherPage: {}
        }
    },
    mutations: {
        updateSelectPageAllPages(state, newContent) {
            console.log('selectPage/updateSelectPageAllPages')
            state.allPages = newContent;

            state.pageSelected = JSON.parse(localStorage.getItem('selectPage/pageSelected') || '[]').reduce((acc,pageId) => {
                if (newContent[pageId])  acc.push(newContent[pageId])
                return acc
            },[])

        },
        updateSelectPagePageSelected(state, newContent) {
            console.log('selectPage/updateSelectPagePageSelected')
            state.pageSelected = newContent;
            localStorage.setItem('selectPage/pageSelected', JSON.stringify(state.pageSelected.map(p => p.id)));
        },
        updateSelectPageGroups(state, newContent) {
            state.groups = newContent;
        },
        updateSelectPageListRetracted(state, newContent) {
            state.listRetracted = newContent;
            localStorage.setItem('selectPage/listRetracted', newContent);
        },
        updateFormatData(state, { groups, otherPage }) { 
            // state.data = { groups, otherPage };
            state.formatData = { groups, otherPage };
        }
    },
    getters: {
        selectPageAllPages(state) {
            return state.allPages;
        },
        selectPagePageSelected(state) {
            return state.pageSelected;
        },
        selectPageGroups(state) {
            return state.groups;
        },
        selectPageStateListRetracted(state) {
            return state.listRetracted;
        },
        formatData(state) {
            return state.formatData;
        },
    },

    actions: {
        generateData({ state, commit }) {
            let allPages = state.allPages
            let groups = state.groups.reduce((acc, group) => {
                group.pages = group.pages.filter(pageId => allPages[pageId]);

                group.pages.forEach(pageId => {
                    if (!allPages[pageId].groups) allPages[pageId].groups = [];
                    allPages[pageId].groups.push(group.id);
                });

                if (group.pages.length) acc[group.id] = group;
                return acc;
            }, {});

            let otherPage = Object.values(allPages).reduce((acc, page) => {
                if (!page.groups || !page.groups.length) {
                    acc[page.id] = page;
                }
                return acc;
            }, {});

            commit('updateSelectPageAllPages', allPages);
            commit('updateFormatData', { groups, otherPage });
        }
    },

};
